import SimpleAppointmentCard from 'components/cards/AppointmentCard/SimpleAppointmentCard/SimpleAppointmentCard'
import styles from './SelectableAppointmentCard.module.sass'

const SelectableAppointmentCard = ({ data, checked, onChange, disabled }) => {
	if (!data) return null

	const handleClick = disabled ? undefined : onChange

	return (
		<div
			className={`${styles.wrapper} ${checked ? styles.selected : ''} ${
				disabled ? styles.disabled : ''
			}`}
			onClick={handleClick}
		>
			<SimpleAppointmentCard appointment={data} />

			<input
				type='checkbox'
				checked={checked}
				disabled={disabled}
				onClick={(e) => e.stopPropagation()}
				onChange={disabled ? () => {} : onChange}
				className={styles.checkbox}
			/>
		</div>
	)
}

export default SelectableAppointmentCard
